// import api2 from '../../models/reportkanban'
import api from '../../models/KanbanAdjust'
import KanbanAdjustUploadModal from '../../components/modal/KanbanAdjustUpload'
export default {
  name: 'KanbanAdjust',
  components: {
    KanbanAdjustUploadModal
  },
  data() {
    return {
      // default
      is_load: false,
      per_page: 100,
      active_page: 1,
      // page
      search_date: null,
      search_text: '',
      result_data: {
        pagination: [],
        count: 0
      },
      is_auto: '99',
      dock: '',
      dock_list: [],
      supplier: '',
      supplier_list: [],
      part: '',
      part_list: [],
      str_data: ''
    }
  },
  created() {
    this.checkOAuth()
    this.active_page = typeof this.$route.params.active_page !== 'undefined' ? this.$route.params.active_page : 1
    this.dock = typeof this.$route.params.dock !== 'undefined' ? this.$route.params.dock : ''
    this.supplier = typeof this.$route.params.supplier !== 'undefined' ? this.$route.params.supplier : ''
    this.part = typeof this.$route.params.part !== 'undefined' ? this.$route.params.part : ''
    this.is_auto = typeof this.$route.params.is_auto !== 'undefined' ? this.$route.params.is_auto : '99'
  },
  mounted() {
    setTimeout(() => {
      if (sessionStorage.token) {
        this.getDock()
        this.getSupplierList()
        this.GetPart()
        this.search()
      } else {
        setTimeout(() => {
          this.getDock()
          this.getSupplierList()
          this.GetPart()
          this.search()
        }, 300)
      }
      // select dock
      $('#select2-dock').select2({
        placeholder: 'Select Dock',
        allowClear: true,
        dropdownPosition: 'below'
      })
      $('#select2-dock').on('select2:select', e => {
        this.changeDock($('#select2-dock').val())
      })
      $('#select2-dock').on('select2:clear', e => {
        this.changeDock('')
      })
      // select part
      $('#select2-supplier').select2({
        placeholder: 'Select Supplier',
        allowClear: true,
        dropdownPosition: 'below'
      })
      $('#select2-supplier').on('select2:select', e => {
        this.changeSupplier($('#select2-supplier').val())
      })
      $('#select2-supplier').on('select2:clear', e => {
        this.changeSupplier('')
      })
      // select part
      $('#select2-part').select2({
        placeholder: 'Select Part',
        allowClear: true,
        dropdownPosition: 'below'
      })
      $('#select2-part').on('select2:select', e => {
        this.changePart($('#select2-part').val())
      })
      $('#select2-part').on('select2:clear', e => {
        this.changePart('')
      })
    }, 1000)
  },
  methods: {
    itemRender(current, type, originalElement) {
      if (type === 'prev') {
        return 'Previous'
      } else if (type === 'next') {
        return 'Next'
      }
      return originalElement
    },
    activePage(value) {
      this.active_page = value
      this.search()
    },
    adjustManage(obj) {
      this.$router.push({
        name: 'KanbanAdjustManage',
        params: {
          ps_id: obj.ps_id,
          active_page: this.active_page,
          dock: this.dock,
          supplier: this.supplier,
          part: this.part,
          is_auto: this.is_auto
        }
      })
    },
    changeDock(id) {
      this.dock = id
      this.getSupplierList()
      this.GetPart()
    },
    changeSupplier(id) {
      this.supplier = id
      this.getDock()
      this.GetPart()
    },
    changePart(id) {
      this.part = id
    },
    getDock() {
      this.dock_list = []
      this.header.params = { spl_id: this.supplier }
      api.getDockBySpl(
        this.$store.state.URLHost,
        this.header,
        result => {
          if (result.response === true) {
            this.dock_list = result.data.dock_list
          } else {
            // this.alert_msg('warning', 'An error occurred.', result.message)
          }
        },
        error => {
          this.alert_msg('error', 'An error occurred.', error.message)
        }
      )
    },
    getSupplierList() {
      this.supplier_list = []
      this.header.params = { dk_id: this.dock }
      api.getSupplierByDk(
        this.$store.state.URLHost,
        this.header,
        result => {
          if (result.response === true) {
            this.supplier_list = result.data.supplier_list
          } else {
            // this.alert_msg('warning', 'An error occurred.', result.message)
          }
        },
        error => {
          this.alert_msg('error', 'An error occurred.', error.message)
        }
      )
    },
    GetPart() {
      this.part_list = []
      this.header.params = { dk_id: this.dock, spl_id: this.supplier }
      api.getPartByDkSpl(
        this.$store.state.URLHost,
        this.header,
        result => {
          if (result.response === true) {
            this.part_list = result.data.part_list
          } else {
            // this.alert_msg('warning', 'An error occurred.', result.message)
          }
        },
        error => {
          this.alert_msg('error', 'An error occurred.', error.message)
        }
      )
    },
    search() {
      this.is_load = true
      var obj = {
        search: this.search_text,
        spl_id: this.supplier,
        dk_id: this.dock,
        part_id: this.part,
        is_auto: this.is_auto,
        limit: this.per_page,
        page: this.active_page
      }
      this.result_data = {
        pagination: [],
        count: 0
      }
      this.header.params = obj
      api.getPartlinkage(
        this.$store.state.URLHost,
        this.header,
        result => {
          if (result.response === true) {
            this.result_data = result.data
          } else {
            this.alert_msg('warning', 'Get Part Linkage', result.message)
          }
          this.is_load = false
        },
        error => {
          this.alert_msg('error', 'Report Part Linkage', error.message)
          this.is_load = false
        }
      )
    },
    // upload V.3
    goKanbanAdjustDayoffUpload() {
      this.$router.push({
        name: 'KanbanAdjustDayoffUpload',
        params: {
          active_page: this.active_page,
          dock: this.dock,
          supplier: this.supplier,
          part: this.part,
          is_auto: this.is_auto
        }
      })
    },
    goKanbanAdjustFactorUpload() {
      this.$router.push({
        name: 'KanbanAdjustFactorUpload',
        params: {
          active_page: this.active_page,
          dock: this.dock,
          supplier: this.supplier,
          part: this.part,
          is_auto: this.is_auto
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/KanbanAdjust.js